export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_q04_a.1cb718b8.png";